import m from 'moment';
import { get } from 'lodash';
import { getEpgChannel, getEpgLineUp } from 'services/api/epg/channel';
import {
  GetNodeId,
  GetEpgVersion,
  tvEverywhereEnable,
} from '../utils/getEpgParams';
import * as ACTIONS from '../actions/epg';

export const setChannels = (result, cb) => ({
  type: ACTIONS.CHANNELS_FETCH,
  result,
  cb,
});
export const patchChannels = (result, cb) => ({
  type: ACTIONS.CHANNELS_PATCH,
  result,
  cb,
});
export const setDates = (result, cb) => ({
  type: ACTIONS.CHANNELS_DATES,
  result,
  cb,
});
export const setGridChannels = (result, cb) => ({
  type: ACTIONS.GRID_CHANNELS_FETCH,
  result,
  cb,
});

export const fetchEpgChannels = () => {
  const now = m().format('YYYYMMDDHH0000');
  const data = {
    date_from: now,
    date_to: now,
    quantity: 50,
    node_id: GetNodeId(),
    epg_version:GetEpgVersion()
  };

  if (GetEpgVersion() && tvEverywhereEnable()) {
    data.epg_version = GetEpgVersion();
  }


  return dispatch =>
    getEpgChannel(data).then(resp => dispatch(setChannels(resp, () => 1)));
};

export const fetchChannelsWithOptions = (forwardingOptions, callback) => (
  dispatch,
  getState,
) => {
  console.log('fetch channels')
  const options = forwardingOptions || {};
  const cb =
    callback ||
    (typeof forwardingOptions === 'function' ? forwardingOptions : undefined);

  const { epg } = getState();
  const { range, isPatch } = options;
  const data = {
    date_from: range.date_from,
    date_to: range.date_to,
    quantity: 200,
    node_id: GetNodeId(),
    epg_version:GetEpgVersion()

  };

  if (GetEpgVersion() && tvEverywhereEnable()) {
    data.epg_version = GetEpgVersion();
  }

  return getEpgChannel(data).then(dataEmp => {
    const resp = Object.assign(dataEmp);
    const status = get(resp, 'status', '1');
    if (status !== '0') return;
    resp.incraseCounter = epg.incraseCounter + 1;
    if (isPatch) return dispatch(patchChannels(resp, cb));
    dispatch(setGridChannels(resp, cb));
    return dispatch(setChannels(resp, cb));
  });
};
